/**
 * Operadoras de saúde conhecidas no Brasil, usadas só como sugestão
 * (autocomplete livre) no nome da operadora em Cadastros > Convênios.
 * A pessoa pode digitar qualquer nome; a lista não limita nada.
 * Especificação: docs/features/convenios/fase-0-desenho-tecnico.md (4.1)
 */
export const INSURANCE_PROVIDER_SUGGESTIONS = [
  'Allianz Saúde',
  'Amil',
  'Assim Saúde',
  'Bradesco Saúde',
  'Care Plus',
  'Cassi',
  'Geap',
  'Golden Cross',
  'Hapvida',
  'Mediservice',
  'NotreDame Intermédica',
  'Odontoprev',
  'Omint',
  'Petrobras Saúde',
  'Porto Seguro Saúde',
  'Postal Saúde',
  'Prevent Senior',
  'SulAmérica',
  'Unimed',
  'Uniodonto',
  'Vivest',
];

export default INSURANCE_PROVIDER_SUGGESTIONS;
